import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-entity-confirm-delete',
  templateUrl: './entity-confirm-delete.component.html',
  styleUrls: ['./entity-confirm-delete.component.css']
})
export class EntityConfirmDeleteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
